/** Steps項目 */
export const K100_STEPS_ITEMS = [
  { label: '入会申請修正' },
  { label: '確認' },
  { label: 'メールアドレス確認' },
  { label: '入会申請修正完了' },
];
